import { TFunction } from "i18next";

import { FoodManagementControls } from "../types/FoodManagementTypes";

export const InventoryTypes = (t: TFunction<"ns1", undefined>) => [
  {
    label: t("food.Freezer"),
    value: FoodManagementControls.freezer,
    color: "primary",
  },
  /*   {
    label: "Cold Room",
    value: FoodManagementControls.coldRoom,
    color: "success",
  }, */
  {
    label: t("food.Cooler"),
    value: FoodManagementControls.cooler,
    color: "success",
  },
  {
    label: t("food.Fish Cooler"),
    value: FoodManagementControls.fishCooler,
    color: "info",
  },
];
